import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.FooterHeader}>
      <li className={styles.ListItem}>Made by Hrusikesh Swain</li>
      <li className={styles.ListItem}>Newsletter</li>
      <ul className={styles.List}>
        {/* <li className={styles.ListItem}>Ko-Fi</li>
        <li className={styles.ListItem}>Patreon</li>
        <li className={styles.ListItem}>RSS</li> */}
      </ul>
      <ul className={styles.List}>
        <li className={styles.ListItem}>
          <i className="fa fa-github"></i> Github
        </li>
        <li className={styles.ListItem}>
          <i className="fa fa-github"></i> Netlify
        </li>
        <li className={styles.ListItem}>
          {" "}
          <i className="fa fa-github"></i> Gatsby
        </li>
      </ul>
    </div>
  );
};

export default Footer;
